<template>
	<div class="shop_map">
		<div class="map_box">
			<div id="echart_china" ref="echart_china"></div>
		</div>
		<el-dialog :visible.sync="popshow" :show-close="false" width="900px" top="100px" center @close="closePop">
			<div class="shop_con">
				<div class="sp_head">
					<div class="aph_d1">
						<p class="aph_d1_p1" @click="selevtPro">
							{{ actPro.name }}
						</p>
						<ul class="aph_d1_ul animate__animated" :class="ulani">
							<li class="aph_d1_li" v-for="(item, index) in proList" :key="index" @click="confirmPro(item)">
								{{ item.properties.name }}
							</li>
						</ul>
					</div>
					<div class="aph_d1">
						<p class="aph_d1_p1" @click="selevtCity">
							{{ actCity.name ? actCity.name : "市/区" }}
						</p>
						<ul class="aph_d1_ul animate__animated" :class="ulani2">
							<li class="aph_d1_li" v-for="(item, index) in cityList" :key="index" @click="confirmCity(item)">
								{{ item.storeCityName }}
							</li>
						</ul>
					</div>
					<div class="aph_d2">
						<input type="text" placeholder="请输入关键字" v-model="keywords" />
						<button @click="searchBtn"></button>
					</div>
				</div>
				<ul class="sp_list" @scroll="handleScroll">
					<li class="sp_item" v-for="item in shopList" :key="item.id">
						<div class="sp_item_con">
							<p class="sp_con_p1">{{ item.storeDoorHead }}</p>
							<p class="sp_con_p2">{{ item.storeAddress }}</p>
							<p class="sp_con_p3">
								{{ item.storeMainLinkmanTel }}
							</p>
						</div>
					</li>
				</ul>
				<div class="zongji">
					共<span>{{ total }}个</span>结果
				</div>
			</div>
		</el-dialog>
		<record></record>
	</div>
</template>

<script>
import echarts from "echarts";
import chinaMap from "echarts/map/json/china.json";
export default {
	data() {
		return {
			shopList: [],
			myChart: null,
			popshow: false,
			proList: [],
			cityList: [],
			actPro: {
				//当前选择的省份
				code: "",
				name: "",
			},
			actCity: {
				//当前选择的市
				code: "",
				name: "",
			},
			ulani: "",
			ulani2: "",
			page: 0,
			keywords: "",
            total:0,
		};
	},
	created() { },
	mounted() {
		this.proList = chinaMap.features;
		this.myChart = echarts.init(this.$refs.echart_china);
		this.init();
	},
	methods: {
		init() {
			echarts.registerMap("china", chinaMap);
			var option = {
				geo: {
					type: "map",
					map: "china",
					label: {
						normal: {
							show: true,
						},
						emphasis: {
							color: "#fff",
						},
					},
					itemStyle: {
						normal: {
							areaColor: "#f6f6f6",
							borderColor: "#bfbfbf",
							borderWidth: 2,
						},
						emphasis: {
							areaColor: "#d43235",
							color: "#fff",
						},
					},
				},
			};
			this.myChart.setOption(option);
			this.myChart.on("click", (params) => {
				if (params.componentType === "geo") {
					for (let i = 0; i < this.proList.length; i++) {
						if (params.name == this.proList[i].properties.name) {
							this.actPro.name = this.proList[i].properties.name;
							this.actPro.code = this.proList[i].properties.id;
							this.popshow = true;
							this.shopList = [];
							this.page = 0;
							this.phoneshi(this.actPro.code);
							this.mdstroe();
						}
					}
				}
			});
		},
		// 店铺列表
		async mdstroe() {
			var data2 = {
				page: this.page,
				nums: 20,
				storeProvinceCode: this.actPro.code,
				storeCityCode: this.actCity.code,
				keyword: this.keywords,
			};
            // console.log(111,data2);
			const res = await this.$api.mdstroe(data2);
            // console.log(222,res);
            this.total = res.msg;
            if (res.data.length) {
                this.page++;
                this.shopList = this.shopList.concat(res.data);
                this.shopList = this.quChong(this.shopList);
            }
		},
		async phoneshi(a) {
			const res = await this.$api.phoneshi({
				storeProvinceCode: a,
			});
			if (res.code == 1) {
				if (res.data.length) {
					this.cityList = res.data;
				} else {
					this.cityList = [];
				}
			}
		},
		selevtPro() {
			if (this.ulani == "" || this.ulani == "animate__fadeOut") {
				this.ulani = "animate__fadeIn";
			} else {
				this.ulani = "animate__fadeOut";
			}
		},
		selevtCity() {
			if (this.ulani2 == "" || this.ulani2 == "animate__fadeOut") {
				this.ulani2 = "animate__fadeIn";
			} else {
				this.ulani2 = "animate__fadeOut";
			}
		},
		closePop() {
			this.ulani = "";
			this.ulani2 = "";
			this.keywords = '';
			this.actCity.name = "";
			this.actCity.code = "";
			this.actPro.name = '';
			this.actPro.code = '';
		},
		confirmPro(item) {
			this.actPro.name = item.properties.name;
			this.actPro.code = item.id;
			this.ulani = "animate__fadeOut";
			this.phoneshi(this.actPro.code);
			this.shopList = [];
			this.page = 0;
			this.actCity.name = "";
			this.actCity.code = "";
			this.mdstroe();
		},
		confirmCity(item) {
			this.actCity.name = item.storeCityName;
			this.actCity.code = item.storeCityCode;
			this.ulani2 = "animate__fadeOut";
			this.shopList = [];
			this.page = 0;
			this.mdstroe();
		},
		searchBtn() {
			this.shopList = [];
			this.page = 0;
			this.mdstroe();
		},
		handleScroll(e) {
			const container = e.target;
			if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
				this.mdstroe();
			}
		},
		quChong(arr) {
			let obj = {}
			return arr.filter((item, index) => {
				let newItem = item + JSON.stringify(item)
				return obj.hasOwnProperty(newItem) ? false : obj[newItem] = true
			})
		}
	},
};
</script>

<style lang="scss">
.shop_map {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	margin-top: 60px;
	padding: 46px 20px 85px;
	min-height: 800px;
	background-image: url("../../images/bgimg3.png");
	box-sizing: border-box;
	.map_box {
		max-width: 1000px;
		margin: 0 auto;
		#echart_china {
			width: 1000px;
			height: 720px;
		}
	}
	.el-dialog__header {
		display: none;
	}
	.el-dialog__body {
		padding: 15px !important;
	}
	.shop_con {
		background-color: #eaeaea;
		padding: 36px 40px;
		.sp_head {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 24px;
			.aph_d1 {
				position: relative;
				.aph_d1_p1 {
					color: #333;
					font-size: 34px;
					cursor: pointer;
					padding-right: 26px;
					background: url("../../images/jiao3.png") no-repeat 100% 100%;
				}
				.aph_d1_ul {
					position: absolute;
					left: 0;
					top: 50px;
					z-index: 9;
					background-color: #fff;
					min-width: 120px;
					max-height: 268px;
					overflow: auto;
					padding: 10px;
					border: 1px solid #fafafa;
					opacity: 0;
					animation-duration: 0.2s;

					.aph_d1_li {
						color: #333;
						font-size: 16px;
						line-height: 2;
						white-space: nowrap;
						cursor: pointer;
					}
				}
			}
			.aph_d2 {
				width: 280px;
				height: 42px;
				border-radius: 5px;
				overflow: hidden;
				display: flex;
				input {
					display: inline-block;
					width: 230px;
					background-color: #fff;
					height: 42px;
					padding: 0 12px;
					color: #333;
					font-size: 14px;
					vertical-align: middle;
					border: 1px solid #d9d9d9;
					outline: none;
				}
				button {
					display: inline-block;
					background-color: #d43235;
					color: #fff;
					width: 50px;
					height: 42px;
					background-image: url("../../images/zoom.png");
					background-repeat: no-repeat;
					vertical-align: middle;
					background-position: 50%;
					cursor: pointer;
					border: 0;
				}
			}
		}
		.sp_list {
			margin: 0 -8px;
			max-height: 584px;
			min-height: 300px;
			overflow: auto;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			.sp_item {
				width: 50%;
				padding: 0 8px;
				margin-bottom: 12px;
				box-sizing: border-box;
				.sp_item_con {
					background-color: #fff;
					padding: 30px 26px 10px 26px;
					box-sizing: border-box;
					height: 186px;
					.sp_con_p1 {
						color: #000;
						font-size: 18px;
						margin-bottom: 15px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
					.sp_con_p2 {
						color: #666;
						font-size: 14px;
						line-height: 2;
					}
					.sp_con_p3 {
						color: #666;
						font-size: 14px;
						line-height: 2;
					}
				}
			}
		}
		.zongji {
			color: #666;
			font-size: 16px;
			margin-top: 8px;
			span {
				color: #c00;
			}
		}
	}
}
</style>